import { rifledCategoryURL, root, smoothboreCategoryURL } from "../config.js";
import { getLocation, logout, menuNavigation } from "../healpers.js";
import icons from 'url:../../images/sprite.svg';
import { addNewRow } from "../weaponListFunctions.js";

export const header = () => {
    const category = getLocation();
    const columnSettings = JSON.parse(localStorage.getItem(`${category === smoothboreCategoryURL ? 'smoothboreSettings' : 'rifledSettings'}`))
    let smoothboreLabelHTML = '';
    let rifledLabelHTML = '';

    if(category === smoothboreCategoryURL) {
        smoothboreLabelHTML = `
        <label class="header-settings__name" data-column="8">
            <input type="checkbox" checked="" name="Длина патрона" data-column-number="8" data-has-filter="1" data-type="bulletLength">
            <div class="header-settings__checkbox">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </div>
            <div>Длина патрона</div>
        </label>
        <label class="header-settings__name" data-column="9">
            <input type="checkbox" checked="" name="Длина ствола" data-column-number="9" data-has-filter="0" data-type="barrelLength">
            <div class="header-settings__checkbox">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </div>
            <div>Длина ствола</div>
        </label>
        `
    }
    if(category === rifledCategoryURL) {
        rifledLabelHTML = `
        <label class="header-settings__name" data-column="19">
            <input type="checkbox" checked="" name="Прицел" data-column-number="24" data-has-filter="0" data-type="aim">
            <div class="header-settings__checkbox">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </div>
            <div>Прицел</div>
        </label>
        `
    }
    let labelHTML = `
    <label class="header-settings__name" data-column="6">
        <input type="checkbox" checked="" name="Тип" data-column-number="6" data-has-filter="1" data-type="subtype">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Тип</div>
    </label>
    <label class="header-settings__name" data-column="7">
        <input type="checkbox" checked="" name="Калибр" data-column-number="7" data-has-filter="1" data-type="caliber">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Калибр</div>
    </label>
    ${smoothboreLabelHTML}
    ${rifledLabelHTML}
    <label class="header-settings__name" data-column="10">
        <input type="checkbox" checked="" name="Спуск. крючок" data-column-number="10" data-has-filter="1" data-type="trigger">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Спусковой крючок</div>
    </label>
    <label class="header-settings__name" data-column="11">
        <input type="checkbox" checked="" name="Цена покупки" data-column-number="11" data-has-filter="0" data-type="purchasePrice">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Цена покупки</div>
    </label>
    <label class="header-settings__name" data-column="12">
        <input type="checkbox" checked="" name="Цена рынок" data-column-number="12" data-has-filter="0" data-type="marketPrice">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Цена рынок</div>
    </label>
    <label class="header-settings__name" data-column="13">
        <input type="checkbox" checked="" name="№ Оружия" data-column-number="13" data-has-filter="0" data-type="weaponNumber">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>№ Оружия</div>
    </label>
    <label class="header-settings__name" data-column="14">
        <input type="checkbox" checked="" name="Кейс" data-column-number="14" data-has-filter="1" data-type="case">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Кейс</div>
    </label>
    <label class="header-settings__name" data-column="15">
        <input type="checkbox" checked="" name="РХ/РОХА" data-column-number="15" data-has-filter="0" data-type="term">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>РХ/РОХА</div>
    </label>
    <label class="header-settings__name" data-column="16">
        <input type="checkbox" checked="" name="Паспорт" data-column-number="16" data-has-filter="0" data-type="passport">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Паспорт</div>
    </label>
    <label class="header-settings__name" data-column="17">
        <input type="checkbox" checked="" name="Год производства" data-column-number="17" data-has-filter="0" data-type="productionYear">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Год производства</div>
    </label>
    <label class="header-settings__name" data-column="22">
        <input type="checkbox" checked="" name="Состояние ружья" data-column-number="22" data-has-filter="0" data-type="weaponCondition">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Состояние ружья</div>
    </label>
    <label class="header-settings__name" data-column="23">
        <input type="checkbox" checked="" name="Состояние ствола" data-column-number="23" data-has-filter="0" data-type="barrelCondition">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Состояние ствола</div>
    </label>
    <label class="header-settings__name" data-column="18">
        <input type="checkbox" checked="" name="Номер полки" data-column-number="18" data-has-filter="0" data-type="shelfNumber">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Номер полки</div>
    </label>
    <label class="header-settings__name" data-column="19">
        <input type="checkbox" checked="" name="Сейф" data-column-number="19" data-has-filter="0" data-type="safe">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Сейф</div>
    </label>
    <label class="header-settings__name" data-column="20">
        <input type="checkbox" checked="" name="Чоки" data-column-number="20" data-has-filter="0" data-type="choki">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Чоки</div>
    </label>
    <label class="header-settings__name" data-column="21">
        <input type="checkbox" checked="" name="Инвест. ценность" data-column-number="21" data-has-filter="0" data-type="investEvaluation">
        <div class="header-settings__checkbox">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
        </div>
        <div>Инвест. ценность</div>
    </label>
    `;

    if(columnSettings){
        labelHTML = '';
        columnSettings.forEach(label => {
            labelHTML += `
            <label class="header-settings__name" data-column="${label.column}">
                <input type="checkbox" ${label.open ? 'checked' : ''} name="${label.name}" data-column-number="${label.column}" data-has-filter="${label.filter}" data-type="${label.columnType}">
                <div class="header-settings__checkbox">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12L10 18L20 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <div>${label.name}</div>
            </label>            
            `
        });
    }
    
    const headerHTML = `
    <div class="header">
        <header class="header-top">
                <div class="container">
                    <div class="header-wrap">
                        <div class="header-logo">
                            <svg width="265" height="40" viewBox="0 0 265 40" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_301_40)">
                                    <circle cx="20" cy="20" r="20" fill="#3571FF" />
                                    <mask id="mask0_301_40" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                        width="40" height="40">
                                        <circle cx="20" cy="20" r="20" fill="#FF4435" />
                                    </mask>
                                    <g mask="url(#mask0_301_40)">
                                        <path
                                            d="M17.8173 10.2653C17.3626 11.9443 17.017 15.8105 19.2724 17.8434C19.3179 17.8888 22.592 21.9274 29.0492 16.709C29.3766 16.9268 30.4286 17.556 30.9136 17.8434C30.2467 18.5241 28.5763 20.0034 27.2303 20.4753C28.7309 20.5963 32.4961 20.194 35.5519 17.6165C36.1704 17.9069 37.1435 18.4938 37.5527 18.7509C35.8702 20.5963 30.6863 23.9059 23.4105 22.3812C23.3378 22.3812 26.3511 24.529 27.8669 25.603C27.4728 26.4803 26.4481 28.3166 25.5023 28.6433C25.4568 28.6433 24.6838 29.0063 22.9558 28.371C21.4097 28.0534 20.9549 28.008 19.7726 28.2349C18.8632 28.4094 17.4535 28.7794 16.0893 30.5491C15.6346 31.1844 14.4522 32.9542 15.1798 35.6314C15.4357 36.5729 16.7863 39.7745 20.639 39.9837C21.0974 39.9862 21.3642 39.9877 21.3642 39.9877C21.1132 39.998 20.8715 39.9963 20.639 39.9837C18.5966 39.9726 12.7519 39.9423 9.76849 39.9423C7.91923 39.8969 4.01155 38.826 2.44727 34.9054C2.44727 34.86 3.12936 24.1055 13.2699 20.7022C12.3908 19.8854 10.878 17.4078 11.8603 14.0317L13.8156 15.4384C12.7394 13.9107 10.8417 9.47575 11.8603 3.95782C12.1513 4.10303 13.2851 4.71412 13.8156 5.00151C13.6944 7.02838 13.7974 11.5177 15.1798 13.2603C15.2253 13.2149 15.4527 9.4939 15.8619 9.13088C16.153 9.31239 17.2868 9.9628 17.8173 10.2653Z"
                                            fill="white" />
                                        <path
                                            d="M14.1339 28.3711C16.7259 27.2974 20.1667 27.645 21.7734 28.1442C12.6788 27.7812 12.9061 39.8828 21.2278 39.9878C17.1958 39.9424 9.26825 39.9333 9.26825 39.897C7.48569 33.1448 11.7238 29.3694 14.1339 28.3711Z"
                                            fill="url(#paint0_linear_301_40)" />
                                        <path
                                            d="M15.5891 20.1577C12.7152 18.9597 11.8906 15.5745 11.8603 14.0317C10.7689 17.5167 12.3757 19.9762 13.27 20.7022L15.5891 20.1577Z"
                                            fill="url(#paint1_linear_301_40)" />
                                    </g>
                                </g>
                                <path
                                    d="M57.383 20.9872L59.3483 12.5923L61.9046 22.0874L59.7916 30H53.8662L48 10H54.5016L57.383 20.9872ZM71.2433 30H65.0077L59.629 10H66.2193L71.2433 30ZM71.3024 10H77.2573L71.9378 28.9601L69.278 18.3044L71.3024 10Z"
                                    fill="white" />
                                <path
                                    d="M85.1331 21.786V30H78.602V10H85.1331V17.9277H91.3836V21.786H85.1331ZM86.1675 13.8734V10H96.378V15.7875H90.231V13.8734H86.1675ZM86.1675 30V26.006H89.8468V24.0015H96.378V30H86.1675Z"
                                    fill="white" />
                                <path
                                    d="M112.396 27.8146H105.983L107.342 23.8508H110.888L105.643 10H112.011L119.828 30H113.223L112.396 27.8146ZM104.239 30H97.9295L104.934 10.9043L107.83 18.847L104.239 30Z"
                                    fill="white" />
                                <path
                                    d="M121.66 30V10H128.073V30H121.66ZM129.108 13.994V10H136.437L140.353 13.994V20.8515L136.437 24.8606H129.108V20.8515H133.851V13.994H129.108Z"
                                    fill="white" />
                                <path
                                    d="M149.322 25.9307H151.775V30H146.751L142.776 26.006V13.994L146.751 10H151.775V14.0543H149.322V25.9307ZM155.306 14.0543H152.809V10H157.877L161.838 13.994V26.006L157.877 30H152.809V25.9307H155.306V14.0543Z"
                                    fill="white" />
                                <path
                                    d="M183.692 30H176.747L164.867 10H171.767L183.692 30ZM164.867 30V11.899L170.556 21.4092V30H164.867ZM183.692 10V28.101L178.003 18.5456V10H183.692Z"
                                    fill="white" />
                                <path
                                    d="M193.858 30V26.006H198.705V13.994H193.858V10H201.32L205.251 13.994V26.006L201.32 30H193.858ZM186.293 10H192.824V30H186.293V10Z"
                                    fill="#3571FF" />
                                <path
                                    d="M221.121 27.8146H214.708L216.067 23.8508H219.613L214.368 10H220.736L228.553 30H221.948L221.121 27.8146ZM212.964 30H206.654L213.658 10.9043L216.555 18.847L212.964 30Z"
                                    fill="#3571FF" />
                                <path
                                    d="M232.587 15.3956H239.384V30H232.587V15.3956ZM227.474 10H244.497V14.3557H227.474V10Z"
                                    fill="#3571FF" />
                                <path
                                    d="M257.234 27.8146H250.821L252.181 23.8508H255.727L250.481 10H256.85L264.667 30H258.062L257.234 27.8146ZM249.078 30H242.768L249.772 10.9043L252.668 18.847L249.078 30Z"
                                    fill="#3571FF" />
                                <defs>
                                    <linearGradient id="paint0_linear_301_40" x1="15.3079" y1="27.667" x2="15.3079"
                                        y2="39.9878" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#3571FF" stop-opacity="0.5" />
                                        <stop offset="1" stop-color="#3571FF" stop-opacity="0.1" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_301_40" x1="13.5414" y1="14.0317" x2="13.5414"
                                        y2="20.7022" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#3571FF" stop-opacity="0.6" />
                                        <stop offset="1" stop-color="#3571FF" stop-opacity="0" />
                                    </linearGradient>
                                    <clipPath id="clip0_301_40">
                                        <rect width="40" height="40" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <nav class="header-nav">
                            <a href="/smoothbore" class="header-nav__item ${category === smoothboreCategoryURL ? 'primary-btn' : ''}">Гладкоствольные</a>
                            <a href="/rifled" class="header-nav__item ${category === rifledCategoryURL ? 'primary-btn' : ''}">Нарезное</a>
                        </nav>
                        <div class="header-actions">
                            <div class="header-search">
                                <input type="search" class="header-search-input" placeholder="Поиск">
                                <svg class="wd-icon header-search-icon">
                                    <use xlink:href="${icons}#search"></use>
                                </svg>
                                <div class="header-search-result"></div>
                            </div>
                            <div class="header-actions__icon header-logout" title="Выход">
                                <svg class="wd-icon">
                                    <use xlink:href="${icons}#logout"></use>
                                </svg>
                            </div>
                            <div class="header-actions__icon header-print" title="Печать" onclick="window.print()">
                                <svg class="wd-icon">
                                    <use xlink:href="${icons}#print"></use>
                                </svg>
                            </div>
                            <div class="header-actions__icon header-settings" title="Настройки колонок">
                                <svg class="wd-icon">
                                    <use xlink:href="${icons}#settings"></use>
                                </svg>
                            </div>
                            <div class="header-actions__icon header-add-weapon" title="Добавить оружие">
                                <svg class="wd-icon">
                                    <use xlink:href="${icons}#add"></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="header-settings-container">
                        ${labelHTML}
                        <div class="secondary-btn header-settings-save">Сохранить</div>
                    </div>
                </div>
            </header>
        </div>
    `;
    
    root.insertAdjacentHTML('afterbegin', headerHTML)
    logout()
    menuNavigation()
    document.querySelector('.header-add-weapon').addEventListener('click', addNewRow)
}